import { env } from './env';
import { getToken } from 'api/axiosApi';

const url = env.REACT_APP_LSNG_ADMIN_API_URL;

export const getApplicationLogo = (isSmall = false) => `${url}/branding/logo?isSmall=${isSmall}&access_token=${getToken()}`;
